import React, { useState } from 'react';
import { Modal } from '@wajeez-web/components/ui';
import { CommonModalProps } from '@wajeez-web/components/modals';
import { useCustomerSelector } from '@wajeez-web/stores/customers';
import { Timeline } from 'antd';
import moment from 'moment';

const UserSubscriptionHistoryTimeLine: React.FC<CommonModalProps<unknown>> = ({
  onClose,
  isOpen,
}) => {
  const { userSubscriptionHistory } = useCustomerSelector(
    (s) => s.usersAnalytics
  );
  return (
    <Modal
      title="User Subscription History"
      withScroll={true}
      onClose={onClose}
      open={isOpen}
    >
      <div className=" mt-3">
        <Timeline mode={'right'}>
          {userSubscriptionHistory &&
            userSubscriptionHistory.map((item, i) => (
              <Timeline.Item
                key={`user-subscription-history-${i}`}
                label={`${moment(item.startDate)
                  .locale('en')
                  .format('DD-MM-YYYY')} - ${
                  item.expirationDate
                    ? moment(item.expirationDate)
                        .locale('en')
                        .format('DD-MM-YYYY')
                    : 'No Expiration Date'
                }`}
              >
                <div>
                  <div className="text-[#727783] text-[14px] font-normal">
                    {item.plan}
                  </div>
                  <div className="text-[#727783] text-[14px] font-normal">
                    {item.productType}
                  </div>
                  <div className="text-[#727783] text-[14px] font-normal">
                    {item.productGroup}
                  </div>
                  <div className="text-[#727783] text-[14px] font-normal">
                    {item.purchaseSource}
                  </div>
                </div>
              </Timeline.Item>
            ))}
        </Timeline>
      </div>
    </Modal>
  );
};

export default UserSubscriptionHistoryTimeLine;
